"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lessonUnzipped = exports.uploadLesson = exports.getAllCustomLessons = exports.getCustomLessonByUuid = exports.updateCustomLesson = exports.createCustomLesson = void 0;
var defaultResponse = {
    id: 12,
    error: '',
    message: 'Operation successfully completed',
    validationErrors: [{ errorKey: '', inputField: '' }],
    success: true,
};
var createCustomLesson = function (_data) { return defaultResponse; };
exports.createCustomLesson = createCustomLesson;
var updateCustomLesson = function (_data) { return defaultResponse; };
exports.updateCustomLesson = updateCustomLesson;
var getCustomLessonByUuid = function (_uuid) { return ({
    data: {
        id: 1,
        uuid: 'test1',
        name: 'My custom lesson',
        description: 'My custom lesson description',
        trackCompletion: true,
        includePoints: false,
        createdBy: 'cb@test.com',
        duration: 5,
        numOfLinkedCourses: 1,
        status: 'linkedToPublished',
    },
}); };
exports.getCustomLessonByUuid = getCustomLessonByUuid;
var getAllCustomLessons = function () {
    var customLessons = __spreadArray([], Array(50), true).map(function (_, i) { return ({
        id: i,
        uuid: 'test2',
        name: 'My custom lesson',
        description: 'My custom lesson description',
        trackCompletion: true,
        includePoints: false,
        lessonDuration: 5,
        createdBy: 'cb@test.com',
        numOfLinkedCourses: 1,
        status: 'linkedToPublished',
    }); });
    return { data: customLessons };
};
exports.getAllCustomLessons = getAllCustomLessons;
var uploadLesson = function () {
    var uuid = 'test3';
    return {
        lesson: {
            signedUrl: "/cb-custom-content-service/tenant/".concat(uuid),
            uuid: uuid,
        },
    };
};
exports.uploadLesson = uploadLesson;
var lessonUnzipped = function () {
    return {
        lessonUnzipped: true,
    };
};
exports.lessonUnzipped = lessonUnzipped;
